import React, {useState, useEffect}from 'react';
import {
  FormControl,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { PropTypes } from 'prop-types';

export function FieldListSearch({
  field, onChange, indexField, indexGroup, indexFormulario, customize,sx
}) {

  
  return (
    <Box  sx={sx?sx:{mb: 0, mt: 2}}>
      <FormControl fullWidth size="small">
        <Autocomplete
          componentsProps={{ popper: { style: { width: 'fit-content' } } }}
          fullWidth
          size="small"
          value={field.options.find(option => option.id === field.value )?.name }
          /* disablePortal */
          options={field.options.map(option => ({label:option.name, id:option.id }))}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField  fullWidth size="small" {...params} label={field.label} InputLabelProps={{ shrink: true }}/>}
          onChange={(event, newValue) => {
            onChange(indexField, newValue!==null ? newValue.id:null, indexGroup, indexFormulario);
          }}
          style={{ width: "100%" }}
        />
        {field.required && (field.value === '' || field.value === undefined || field.value === null) && (
          <FormHelperText sx={{ fontSize: customize.HelperText.size, color: customize.HelperText.color }} error>{`${field.required ? '* Campo Obligatorio' : ''}`}</FormHelperText>
        )}

      </FormControl>
    </Box>
  );
}

FieldListSearch.propTypes = {
  field: PropTypes.objectOf.isRequired,
  onChange: PropTypes.func.isRequired,
  indexField: PropTypes.number.isRequired,
  indexGroup: PropTypes.number.isRequired,
  indexFormulario: PropTypes.number.isRequired,
  customize: PropTypes.objectOf.isRequired,
};

export default FieldListSearch;
